import { render, staticRenderFns } from "./GroupDetailActivity.vue?vue&type=template&id=01e2eda6&scoped=true"
import script from "./GroupDetailActivity.vue?vue&type=script&lang=js"
export * from "./GroupDetailActivity.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailActivity.vue?vue&type=style&index=0&id=01e2eda6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e2eda6",
  null
  
)

export default component.exports